import { useMemo } from "react";
import { useParams } from "react-router";
import { useGetSalesNetworksQuery } from "store/api";

export const useSalesNetworks = () => {
  const { data, isLoading } = useGetSalesNetworksQuery();

  const result = useMemo(() => {
    return { data, isLoading };
  }, [data, isLoading]);

  return result;
};

export const useSalesNetwork = () => {
  const { data, isLoading } = useSalesNetworks();
  const params = useParams();

  const result = useMemo(() => {
    if (isLoading) {
      return { isLoading, network: undefined };
    }

    return {
      isLoading,
      network: data?.find(
        (i) => i.code.toLowerCase() === params.network?.toLowerCase()
      ),
    };
  }, [data, isLoading, params.network]);

  return result;
};
